var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"appear":"","enter-active-class":"animated fadeIn"}},[_c('div',[_c('b-loading',{attrs:{"is-full-page":true,"active":!_vm.content}}),_c('div',{staticClass:"level-item"},[_c('h1',{staticClass:"title is-1 page-title"},[_vm._v("CONTACT US")])]),_c('contact-us-box')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }